export default "__VITE_ASSET__DYhiIaDM__"